export const openInstagram = () => {
  window.open("https://www.instagram.com/pontes.tec", "_blank");
};